import { render } from "./matching-list-interests-mutual.vue?vue&type=template&id=f0822bcc&scoped=true&ts=true"
import script from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts"
export * from "./matching-list-interests-mutual.vue?vue&type=script&lang=ts"

import "./matching-list-interests-mutual.vue?vue&type=style&index=0&id=f0822bcc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0822bcc"]])

export default __exports__